// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"317":"b9b9fb66","471":"c8342601"}[chunkId] + ".chunk.css";
};